mutation CorporateChartOfAccountDelete(
  $input: CorporateChartOfAccountDeleteInput!
) {
  corporateChartOfAccountDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
